'use client';

import { useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Box, Button, Heading, IndicatorDots, Tweet, TweetCard } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { ContainerTwoColumns } from 'components/container-two-column/container-two-column';
import { useLocale } from 'next-intl';
import CardAnimation from './card-animations.module.css';
import css from './prefooter.module.css';
function Prefooter() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'channelpartners');
  const [activeTweetIdx, setActiveTweetIdx] = useState(0);
  const [nextTweetIdx, setNextTweetIdx] = useState(1);
  const applicationUrl = 'https://application.partnerstack.com/application?company=doist&group=ambassadorslandingpage';
  const tweets = [new Tweet('Eihab Khan', 'eihab_khan', t('prefooter.tweets.EihabKhan.title'), t('prefooter.tweets.EihabKhan.quote'), {
    src: '/static/channel-partners/twitter-avatar-eihab@2x.jpg',
    webp: ''
  }, 'https://twitter.com/eihab_khan/status/1009325989971841024'), new Tweet('Stewart Elliot', 'stewcelliott', t('prefooter.tweets.StewCElliott.title'), t('prefooter.tweets.StewCElliott.quote'), {
    src: '/static/channel-partners/twitter-avatar-stewart@2x.jpg',
    webp: ''
  }, 'https://twitter.com/StewCElliott/status/1214869089979641856'), new Tweet('Mark Hendy', 'markhendyhr', t('prefooter.tweets.MarkHendyHR.title'), t('prefooter.tweets.MarkHendyHR.quote'), {
    src: '/static/channel-partners/twitter-avatar-mark@2x.jpg',
    webp: ''
  }, 'https://twitter.com/MarkHendyHR/status/1022564925829468161')];
  function goToNextTweet() {
    setActiveTweetIdx(activeTweetIdx + 1 > tweets.length - 1 ? 0 : activeTweetIdx + 1);
    setNextTweetIdx(activeTweetIdx + 2 > tweets.length - 1 ? 0 : activeTweetIdx + 2);
  }
  return <Box className={css.prefooterBackground} style={{
    '--background-color': 'var(--composition-background-red)'
  }} data-sentry-element="Box" data-sentry-component="Prefooter" data-sentry-source-file="prefooter.tsx">
            <ContainerTwoColumns width="base" className={css.container} breakAbove="lg" data-sentry-element="ContainerTwoColumns" data-sentry-source-file="prefooter.tsx">
                <ContainerTwoColumns.BodyContainer className={css.leftColumn} data-sentry-element="unknown" data-sentry-source-file="prefooter.tsx">
                    <Heading level="2" size="major-lg" data-sentry-element="Heading" data-sentry-source-file="prefooter.tsx">
                        {t('prefooter.title')}
                    </Heading>
                    <Button size="large" href={applicationUrl} data-sentry-element="Button" data-sentry-source-file="prefooter.tsx">
                        {t('prefooter.cta')}
                    </Button>
                </ContainerTwoColumns.BodyContainer>

                <Box className={css.rightColumn} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                    <Box className={css.tweetsContainer} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                        <Box className={css.tweets} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                            <Box className={css.dummyCard} onClick={goToNextTweet} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx" />
                            <Box className={css.nextCard} onClick={goToNextTweet} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                                <TweetCard tweet={tweets[nextTweetIdx]} className={css.tweet} data-sentry-element="TweetCard" data-sentry-source-file="prefooter.tsx" />
                            </Box>

                            <TransitionGroup component={null} data-sentry-element="TransitionGroup" data-sentry-source-file="prefooter.tsx">
                                <CSSTransition key={`tweet-${activeTweetIdx}`} timeout={600} classNames={CardAnimation} data-sentry-element="CSSTransition" data-sentry-source-file="prefooter.tsx">
                                    <Box className={cn(css.currentCard, css.active)} onClick={goToNextTweet} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                                        <TweetCard tweet={tweets[activeTweetIdx]} className={css.tweet} data-sentry-element="TweetCard" data-sentry-source-file="prefooter.tsx" />
                                    </Box>
                                </CSSTransition>
                            </TransitionGroup>
                        </Box>
                        <TweetControls activeTweetIdx={activeTweetIdx} onClick={goToNextTweet} tweets={tweets} data-sentry-element="TweetControls" data-sentry-source-file="prefooter.tsx" />
                    </Box>
                </Box>
            </ContainerTwoColumns>
        </Box>;
}
type TweetControlsProps = {
  activeTweetIdx: number;
  onClick: () => void;
  tweets: Tweet[];
};
function TweetControls({
  activeTweetIdx,
  onClick,
  tweets
}: TweetControlsProps) {
  return <IndicatorDots activeIndex={activeTweetIdx} labels={tweets.map(t => t.username)} onSelectIndex={onClick} data-sentry-element="IndicatorDots" data-sentry-component="TweetControls" data-sentry-source-file="prefooter.tsx" />;
}
export { Prefooter };